<template>
  <div class="header-container h-92 bg-main">
    <div class="flex align-center justify-between padding-lr-45 header-wrapper">
      <div class="header-center flex align-center">
        <div class="text-white text-17 text-bold header-title">
          在线答题教育平台
        </div>
        <el-menu :default-active="activeIndex" background-color="transparent" text-color="#fff" active-text-color="#fff"
          class="header-menu" mode="horizontal" router @select="handleSelect">
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/messages" class="message-item">
            消息
            <el-badge :value="messageCount" :hidden="messageCount === 0" class="message-badge">
            </el-badge>
          </el-menu-item>
          <el-menu-item index="/about">关于平台</el-menu-item>
          <el-menu-item index="/contact">联系我们</el-menu-item>
        </el-menu>
      </div>
      <div class="flex align-center">
        <template v-if="!isLoggedIn">
          <span class="padding-right-15 text-white cursor-pointer" @click="goToLogin">登录</span>
          <img src="@/assets/bg.png" class="w-40 h-40 radius-50" />
        </template>
        <template v-else>
          <el-dropdown trigger="hover" @command="handleUserCommand">
            <span class="user-dropdown text-white">
              <span class="padding-right-10">{{ displayUserName }}</span>
              <img :src="userAvatar" class="w-40 h-40 radius-50" />

            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人中心</el-dropdown-item>
              <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { getHomeMsgTotal } from '@/api/common'

export default {
  name: "Header",
  data() {
    return {
      activeIndex: "/",
      messageCount: 0, 
    };
  },
  computed: {
    ...mapGetters(['getUserInfo', 'getUserName', 'getUserAvatar']),
    ...mapState({
      userInfo: state => state.userInfo,
    }),
    isLoggedIn() {
      return !!(localStorage.getItem("isLoggedIn") || this.$store.state.token);
    },
    userAvatar() {
      const avatar = this.userInfo?.avatar || this.getUserAvatar;
      return avatar || localStorage.getItem("avatar");
    },
    displayUserName() {
      
      const name = this.userInfo?.nickname || this.userInfo?.username || this.getUserName;
      return name || localStorage.getItem("username") || "";
    },
  },
  created() {
    
    if (localStorage.getItem("isLoggedIn")) {
      
      const vuexUserInfo = this.$store.state.userInfo;
      if (!vuexUserInfo || (!vuexUserInfo.username && !vuexUserInfo.nickname)) {
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr) {
          try {
            const userInfo = JSON.parse(userInfoStr);
            this.$store.commit('SET_USER_INFO', userInfo);
          } catch (e) {
            console.error('Failed to parse userInfo in Header', e);
          }
        }
      }
    }
  },
  mounted() {
    this.checkLoginStatus();
    this.updateActiveIndex();
    
    if (this.isLoggedIn) {
      
      if (!this.userInfo || (!this.userInfo.username && !this.userInfo.nickname)) {
        
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr) {
          try {
            const userInfo = JSON.parse(userInfoStr);
            this.$store.commit('SET_USER_INFO', userInfo);
          } catch (e) { }
        }
        
        if (!this.userInfo || (!this.userInfo.username && !this.userInfo.nickname)) {
          this.fetchUserInfo().catch(() => { });
        }
      }
      
      this.loadHomeMsgTotal();
    }
    
    this.$bus.$on('update-message-count', this.handleUpdateMessageCount);
    
    this.$bus.$on('user-login', this.handleUserLogin);
  },
  beforeDestroy() {
    
    this.$bus.$off('update-message-count', this.handleUpdateMessageCount);
    this.$bus.$off('user-login', this.handleUserLogin);
  },
  watch: {
    $route(to) {
      
      const headerMenuPaths = ['/', '/messages', '/about', '/contact'];
      if (headerMenuPaths.includes(to.path)) {
        this.updateActiveIndex();
      }
    },
    
    userInfo: {
      handler(newVal) {
        
        if (newVal && (newVal.username || newVal.nickname)) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      },
      deep: true,
      immediate: true
    },
    
    '$store.state.userInfo': {
      handler(newVal) {
        
        if (newVal && (newVal.username || newVal.nickname)) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      },
      deep: true,
      immediate: true
    },
    
    '$store.state.token': {
      handler(newVal) {
        
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['fetchUserInfo', 'updateUserInfo', 'clearUserInfo']),
    
    loadHomeMsgTotal() {
      getHomeMsgTotal()
        .then((res) => {
          this.messageCount = res.data || 0;
        });
    },
    
    handleUpdateMessageCount(count) {
      this.messageCount = count;
    },
    
    handleUserLogin() {
      
      this.loadHomeMsgTotal();
    },
    
    checkLoginStatus() {
      
    },

    
    updateActiveIndex() {
      this.activeIndex = this.$route.path;
    },

    
    handleSelect(key) {
      this.activeIndex = key;
    },

    
    goToLogin() {
      this.$router.push("/login");
    },

    
    handleUserCommand(command) {
      switch (command) {
        case "profile":
          this.$router.push("/profile");
          break;
        case "settings":
          this.$router.push("/settings");
          break;
        case "logout":
          this.handleLogout();
          break;
      }
    },

    
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          
          this.$bus.$emit('user-logout');

          
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("token");
          localStorage.removeItem("need-review");
          
          this.clearUserInfo();
          
          this.$router.push("/login");

          this.$message.success("退出登录成功！");
        })
        .catch(() => {
          
        });
    },
  },
};
</script>

<style scoped lang="scss">
.header-container {
  width: 100%;
  overflow: hidden;

  :deep(.user-dropdown) {
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      border: 2px solid rgba(255, 255, 255, 0.4);
    }
  }

  position: sticky;
  top: 0;
  z-index: 1000;

  .header-wrapper {
    min-width: 0;
    flex-wrap: nowrap;
    overflow: hidden;
  }

  >div {
    min-width: 0;
    flex-shrink: 1;
  }
}

.header-center {
  flex: 1;
  overflow: hidden;
  flex-wrap: nowrap;

  .header-title {
    flex-shrink: 0;
    white-space: nowrap;
    padding-right: 5%;
  }

  .header-menu {
    border-bottom: none;
    height: 92px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow: hidden;
    flex: 1;
  }
}


@media (min-width: 768px) and (max-width: 1440px) {
  .header-container {
    .h-92 {
      height: 80px !important;
    }

    .padding-lr-45 {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
  }

  .header-center {
    .header-title {
      .text-17 {
        font-size: 15px !important;
      }
    }

    .header-menu {
      height: 80px !important;

      .el-menu-item {
        font-size: 14px !important;
        padding: 0 12px !important;
      }
    }
  }

  .padding-right-15 {
    padding-right: 10px !important;
  }

  .w-40 {
    width: 35px !important;
  }

  .h-40 {
    height: 35px !important;
  }

  .padding-right-10 {
    padding-right: 8px !important;
  }
}
@media (min-width: 600px) and (max-width: 767px) {
  .header-container {
    height: 60px !important;

    .h-92 {
      height: 60px !important;
    }

    .padding-lr-45 {
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
  }

  .header-center {
    .header-title {
      .text-17 {
        font-size: 13px !important;
      }

      padding-right: 3% !important;
    }

    .header-menu {
      height: 60px !important;

      .el-menu-item {
        font-size: 12px !important;
        padding: 0 8px !important;
      }
    }
  }

  .padding-right-15 {
    padding-right: 8px !important;
  }

  .w-40 {
    width: 30px !important;
  }

  .h-40 {
    height: 30px !important;
  }

  .padding-right-10 {
    padding-right: 6px !important;
  }

  ::v-deep .header-menu {
    .el-menu-item {
      height: 60px !important;
      line-height: 60px !important;
      font-size: 12px !important;

      &::after {
        bottom: 16px;
        width: 24px;
        height: 4px;
      }

      &.message-item {
        &::after {
          width: 20px;
        }
      }

      &.is-active {
        &.message-item {
          &::after {
            width: 20px;
          }
        }
      }
    }
  }

  ::v-deep .el-badge__content {
    font-size: 10px !important;
    height: 14px !important;
    line-height: 14px !important;
    min-width: 14px !important;
    padding: 0 4px !important;
  }
}

::v-deep .header-menu {
  display: flex;
  justify-content: space-around;
  align-content: center;

  .el-menu-item {
    text-align: center;
    height: 92px !important;
    line-height: 92px !important;
    border-bottom: none !important;
    color: #F2F3FB !important;
    font-size: 16px;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    position: relative;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    background-color: transparent !important;
    &::after {
      content: "";
      position: absolute;
      bottom: 26px;
      left: 50%;
      transform: translateX(-50%) scaleX(0);
      width: 33px;
      height: 6px;
      background: linear-gradient(90deg, #fff 0%, #e8f0ff 50%, #fff 100%);
      box-shadow: 0 2px 8px rgba(255, 255, 255, 0.3);
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      opacity: 0;
    }

    &:hover {
      background-color: transparent !important;
      color: #fff !important;
      transform: translateY(-1px);

      &::after {
        transform: translateX(-50%) scaleX(0.6);
        opacity: 0.7;
      }
    }

    &.is-active {
      color: #fff !important;
      font-weight: bold;

      &::after {
        transform: translateX(-50%) scaleX(1);
        opacity: 1;
        box-shadow: 0 3px 12px rgba(255, 255, 255, 0.4);
      }

      &.message-item {
        &::after {
          width: 28px;
          left: 45%;
        }
      }
    }
    &.message-item {
      &::after {
        width: 28px;
        left: 45%;
      }
    }
  }
}

.el-badge__content {
  font-size: 12px !important;
  height: 18px !important;
  line-height: 18px !important;
  min-width: 18px !important;
  padding: 0 6px !important;
  color: #fff !important;
}

::v-deep .el-badge {
  vertical-align: middle !important;
  position: relative;
  top: -8px;
  right: -10px;
}

::v-deep .el-badge__content {
  background-color: #f71908 !important;
  border-radius: 12px 25px 25px 0 !important;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  border: none !important;
  font-size: 12px;
  font-weight: normal;
}
</style>
